import { Component } from '@angular/core';


@Component({
	selector: 'lb-default-grid-data-cell',
	standalone: true,
	imports: [],
	template: '<ng-content></ng-content>',
	styleUrl: './default-grid-data-cell.component.scss'
})
export class DefaultGridDataCellComponent {}
